<template>
    <div v-if="loading" class="expiracao-banner">
        <v-skeleton-loader
                type="card"
                :loading="true"
                class="skeleton-loader"
                height="80"
        >
            <div style="height: 80px"></div>
        </v-skeleton-loader>
    </div>
    <div v-else-if="expiracaoInfo" class="expiracao-banner" :class="getExpiracaoTextColorClass(expiracaoInfo.dias_para_expirar)">
        <div class="banner-content" :style="{ backgroundColor: `var(--${getBackgroundColor(expiracaoInfo.dias_para_expirar)})` }">
            <div class="banner-text">
                <div class="expiracao-text" :style="`color: ${textoExpiracao.color}`">
                    <v-icon :color="textoExpiracao.color" size="24" class="mr-2">{{ getIcon(expiracaoInfo.dias_para_expirar) }}</v-icon>
                    {{ textoExpiracao.text }}
                </div>
                <div v-if="expiracaoInfo.dias_para_expirar < DIAS_EXPIRACAO.SUCESS" class="suporte-text" :style="`color: ${textoExpiracao.color}`">
                    Entre em contato com a <strong>Área de Suporte</strong> para normalizar!
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { format } from 'date-fns'
  import { ptBR } from 'date-fns/locale'
  import { getExpiracaoTextColorClass, getBackgroundColor, getIcon, DIAS_EXPIRACAO } from '@/plugins/expiracao_helpers'

  export default {
    name: 'ExpiracaoBanner',
    props: {
      idCarrinho: {
        type: [Number, String],
        required: true
      }
    },
    data () {
      return {
        loading: true,
        expiracaoInfo: null,
        DIAS_EXPIRACAO
      }
    },
    computed: {
      textoExpiracao () {
        if (!this.expiracaoInfo) return ''
        const colorBackground = getBackgroundColor(this.expiracaoInfo.dias_para_expirar)
        const color = (colorBackground === 'success' || colorBackground === 'error') ? 'white' : 'black'
        const jaExpirou = this.expiracaoInfo.dias_para_expirar < 0
        const dataFormatada = this.formatarData(this.expiracaoInfo.dt_validade)

        if (jaExpirou) {
          return { text: `Existem cotas que expiraram em ${dataFormatada}`, color }
        } else {
          return { text: `Existem cotas que irão expirar em ${dataFormatada}`, color }
        }
      }
    },
    async created () {
      await this.buscarInformacoesExpiracao()
    },
    methods: {
      getExpiracaoTextColorClass,
      getBackgroundColor,
      getIcon,
      async buscarInformacoesExpiracao () {
        try {
          const response = await this.$http.get('/carrinho/reservas-expiracao', {
            params: {
              id_carrinho: this.idCarrinho
            }
          })

          if (response.data && response.data.length > 0) {
            this.expiracaoInfo = response.data.reduce((a, b) =>
              new Date(a.dt_validade) < new Date(b.dt_validade) ? a : b
            )
          }
        } catch (error) {
          console.error('Erro ao buscar informações de expiração:', error)
        } finally {
          this.loading = false
        }
      },
      formatarData (data) {
        if (!data) return ''
        return format(new Date(data), 'dd/MM/yyyy', { locale: ptBR })
      }
    }
  }
</script>

<style scoped>
.expiracao-banner {
    margin: 16px 0;
    border-radius: 4px;
    overflow: hidden;
}

.banner-content {
    display: flex;
    align-items: center;
    padding: 16px;
    min-height: 80px;
}

.banner-text {
    flex: 1;
}

.expiracao-text {
    font-weight: 600;
    font-size: 1.2rem;
    margin-bottom: 4px;
    display: flex;
    align-items:center;
    color: black;
}

.suporte-text {
    font-size: 1.1rem;
    color: black;
}

.skeleton-loader {
    border-radius: 4px;
}

:deep(.v-skeleton-loader__article) {
    border-radius: 4px;
    height: 80px !important;
}
</style>
